import { BaseService } from '@/modules/Core/services/BaseService'
import type { ICitaDocjson } from '@/modules/Asistencial/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces'
export class DocJsonDiligenciadosService extends BaseService<ICitaDocjson> {
  constructor () {
    super({
      baseUrl: 'scheduling/docjson/'
    })
  }
  async createMulti(data:  ICitaDocjson[]): Promise<AxiosResponse<IResponseApi<ICitaDocjson[]>>> {
      return this.http.post<ICitaDocjson[]>(`/create-multi`, data).catch(this.errorHandle)
    }
  
}
